import React, { useEffect, useState } from "react";
import "./Projects.css";
import { FaGithub, FaArrowUpRightFromSquare } from "react-icons/fa6";
import { api, assetUrl } from "./api";

// Shown instantly and used as a fallback if the server is unreachable.
// Once the API answers, the projects managed in the admin panel replace these.
const FALLBACK = [
  {
    id: "f1",
    title: "Vehicle QR System",
    description: "QR-based vehicle management system for secure access and tracking, with a responsive React dashboard.",
    tech: ["React", "Spring Boot", "MySQL"],
    color: "#ffe3da",
  },
  {
    id: "f2",
    title: "Skillora",
    description: "AI-powered learning platform with personalized courses, quizzes and an interactive learner experience.",
    tech: ["React", "Java", "AI"],
    color: "#dcebe4",
  },
  {
    id: "f3",
    title: "MSJ School",
    description: "Modern school website with responsive design, smooth navigation and dynamic content.",
    tech: ["React", "Firebase"],
    color: "#fff1cc",
    live: "https://msjschool.com",
  },
  {
    id: "f4",
    title: "Digital Journaling",
    description: "Blogging platform for writing, organizing and sharing articles with a clean reading experience.",
    tech: ["React", "Spring Boot", "MySQL"],
    color: "#e6e4ff",
  },
];

const PALETTE = ["#ffe3da", "#dcebe4", "#fff1cc", "#e6e4ff", "#dff3fb", "#fde0ef"];

const fromApi = (p, i) => ({
  id: p.id,
  title: p.title,
  description: p.description,
  tech: (p.techStack || "").split(",").map((t) => t.trim()).filter(Boolean),
  color: p.coverColor || PALETTE[i % PALETTE.length],
  image: assetUrl(p.imageUrl) || null,
  live: p.liveUrl || null,
  github: p.githubUrl || null,
});

const isLink = (u) => u && u !== "#";

const Projects = () => {
  const [projects, setProjects] = useState(FALLBACK);

  useEffect(() => {
    let cancelled = false;
    api("/api/projects")
      .then((res) => {
        if (!cancelled && res && Array.isArray(res.data)) setProjects(res.data.map(fromApi));
      })
      .catch(() => {
        // keep the fallback list
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <section className="section projects" id="projects">
      <div className="container">
        <span className="section-tag reveal">Selected work</span>
        <h2 className="section-title reveal" style={{ "--d": "80ms" }}>
          Projects I'm <em>proud</em> of
        </h2>
        <p className="section-sub reveal" style={{ "--d": "140ms" }}>
          React-first builds with responsive UI, clean code and real-world use.
        </p>

        <div className="project-list">
          {projects.map((p, i) => (
            <article className="project reveal" key={p.id}>
              <span className="project-num">{String(i + 1).padStart(2, "0")}</span>

              <div className="project-cover tilt" style={{ background: p.color }}>
                {p.image ? <img src={p.image} alt={`${p.title} screenshot`} loading="lazy" /> : <span>{p.title}</span>}
              </div>

              <div className="project-body">
                <h3>{p.title}</h3>
                <p>{p.description}</p>
                <div className="tech-stack">
                  {p.tech.map((t) => (
                    <span key={t}>{t}</span>
                  ))}
                </div>
              </div>

              <div className="project-links">
                {isLink(p.live) ? (
                  <a href={p.live} target="_blank" rel="noopener noreferrer" aria-label={`${p.title} live site`}>
                    <FaArrowUpRightFromSquare />
                  </a>
                ) : (
                  <span className="soon">Coming soon</span>
                )}
                {isLink(p.github) && (
                  <a href={p.github} target="_blank" rel="noopener noreferrer" aria-label={`${p.title} source code`}>
                    <FaGithub />
                  </a>
                )}
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
